export default "__VITE_ASSET__CQlfxQis__"